export default __webpack_public_path__ + "assets/documentation.460063bd.svg";